var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLucky7Icon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.792 6.5625H11.167C10.1227 6.5625 9.12118 6.97734 8.38276 7.71577C7.64434 8.45419 7.22949 9.45571 7.22949 10.5V13.125M29.542 6.5625H32.167C33.2113 6.5625 34.2128 6.97734 34.9512 7.71577C35.6896 8.45419 36.1045 9.45571 36.1045 10.5V13.125M36.1045 28.875V31.5C36.1045 32.5443 35.6896 33.5458 34.9512 34.2842C34.2128 35.0227 33.2113 35.4375 32.167 35.4375H29.542M13.792 35.4375H11.167C10.1227 35.4375 9.12118 35.0227 8.38276 34.2842C7.64434 33.5458 7.22949 32.5443 7.22949 31.5V28.875M26.917 21C26.917 22.3924 26.3639 23.7277 25.3793 24.7123C24.3947 25.6969 23.0594 26.25 21.667 26.25C20.2746 26.25 18.9392 25.6969 17.9547 24.7123C16.9701 23.7277 16.417 22.3924 16.417 21C16.417 19.6076 16.9701 18.2723 17.9547 17.2877C18.9392 16.3031 20.2746 15.75 21.667 15.75C23.0594 15.75 24.3947 16.3031 25.3793 17.2877C26.3639 18.2723 26.917 19.6076 26.917 21Z",
    stroke: "url(#paint0_linear_6447_27615)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6447_27615",
    x1: 12.0144,
    y1: 17.9999,
    x2: 41.8203,
    y2: 41.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLucky7Icon3);
export default __webpack_public_path__ + "static/media/jokerProLucky7Icon3.6324b75f9dd9160ab9d5d7d4699298fd.svg";
export { ForwardRef as ReactComponent };